<template>
  <div>
    <v-layout justify-space-around wrap>
      <v-flex xs6 md4 class="text-center">
        <h4 class="mb-4">
          {{ $t("modules.home.devices") }}
        </h4>
        <div class="d-flex justify-center mb-2">
          <h4 class="mr-1 teal--text">
            {{ $t("modules.home.online") }}
          </h4>
          <h4 class="grey--text">/ {{ $t("modules.home.total") }}</h4>
        </div>
        <v-progress-circular
          :rotate="270"
          :size="120"
          :width="20"
          :value="(status.online / status.total) * 100"
          color="home__devices_status__online"
          id="devices__status--online"
        >
          <h2>{{ status.online }}</h2>
          <h2 class="grey--text">
            {{ "/" + status.total }}
          </h2>
        </v-progress-circular>
      </v-flex>
      <v-flex xs6 md4 class="text-center">
        <h4>
          {{ $t("modules.home.instantThroughput") }}
        </h4>
        <h5 class="grey--text">[{{ $t("modules.home.mb") }}]</h5>
        <div class="d-flex justify-center mb-2">
          <div class="d-flex flex-column align-end">
            <h4 class="download_text">{{ $t("modules.home.download") }}</h4>
            <div class="columnbar mt-2" v-if="totalDownload">
              <strong
                class="bar download_bar"
                :style="{
                  height: (totalDownload / totalData) * 100 + '%'
                }"
                >{{ totalDownload }}</strong
              >
            </div>
          </div>
          <h4 class="mx-1 grey--text">|</h4>
          <div class="d-flex flex-column align-start">
            <h4 class="upload_text">
              {{ $t("modules.home.upload") }}
            </h4>
            <div class="columnbar mt-2" v-if="totalUpload">
              <strong
                class="bar upload_bar"
                :style="{
                  height: (totalUpload / totalData) * 100 + '%'
                }"
                >{{ totalUpload }}</strong
              >
            </div>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 md4 class="text-center">
        <h4>
          {{ $t("modules.home.links") }}
        </h4>
        <h5 class="grey--text">
          ({{ $t("modules.home.outOfOnlineDevices") }})
        </h5>
        <div class="d-flex justify-center mb-2">
          <div class="d-flex flex-column align-end">
            <h4 class="red--text">
              {{ $t("modules.home.down") }}
            </h4>
            <div class="columnbar mt-2" v-if="status.downLinks">
              <strong
                class="bar downlinks_bar"
                :style="{
                  height: (status.downLinks / status.totalLinks) * 100 + '%'
                }"
                >{{ status.downLinks }}</strong
              >
            </div>
          </div>
          <h4 class="mx-1 grey--text">|</h4>
          <div class="d-flex flex-column align-start">
            <h4 class="teal--text">{{ $t("modules.home.up") }}</h4>
            <div class="columnbar mt-2" v-if="status.upLinks">
              <strong
                class="bar uplinks_bar"
                :style="{
                  height: (status.upLinks / status.totalLinks) * 100 + '%'
                }"
                >{{ status.upLinks }}</strong
              >
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "DevicesStatus",
  props: {
    status: Object,
    totalUpload: Number,
    totalDownload: Number
  },
  computed: {
    totalData() {
      let sum = this.totalUpload + this.totalDownload;
      return parseFloat(sum.toFixed(1));
    }
  }
};
</script>

<style>
.columnbar {
  width: 35px;
  height: 120px;
  background-color: #d8d8d8;
  position: relative;
}
.bar {
  width: 100%;
  display: block;
  font-size: 12px;
  position: absolute;
  bottom: 0;
}
.downlinks_bar {
  background-color: red;
  color: #fff;
}
.uplinks_bar {
  background-color: teal;
  color: #fff;
}
.download_bar {
  background-color: #7094d6;
  color: #222;
}
.upload_bar {
  background-color: #fade92;
  color: #222;
}
.download_text {
  color: #7094d6;
}
.upload_text {
  color: #e2c985;
}
</style>
